export const enum RelationClassificationEnum {
  FTL = 1,
  LTL = 2,
  JitKanban = 8,
  LCL = 32,
  OutOfScope = 16,
  FTL2 = 64,
}

const enum RelationClassification {
  FTL = "FTL",
  LTL = "LTL",
  JitKanban = "JIT / Kanban",
  LCL = "LCL",
  OutOfScope = "Out of Scope",
  FTL2 = "FTL2",
}

export const relationClassificationAsString = new Map([
  [RelationClassificationEnum.FTL, RelationClassification.FTL],
  [RelationClassificationEnum.FTL2, RelationClassification.FTL2],
  [RelationClassificationEnum.JitKanban, RelationClassification.JitKanban],
  [RelationClassificationEnum.LCL, RelationClassification.LCL],
  [RelationClassificationEnum.LTL, RelationClassification.LTL],
  [RelationClassificationEnum.OutOfScope, RelationClassification.OutOfScope],
]);

export const pdsrClassificationData = [
  { Classification: RelationClassification.FTL },
  { Classification: RelationClassification.FTL2 },
  { Classification: RelationClassification.LTL },
  // Corresponds to "not routed" and NULL on the Database
  { Classification: "-" },
];

export const spdrClassificationData = [
  { SpdrClassification: RelationClassification.FTL },
  { SpdrClassification: RelationClassification.FTL2 },
  { SpdrClassification: RelationClassification.JitKanban },
  { SpdrClassification: RelationClassification.LCL },
  { SpdrClassification: RelationClassification.LTL },
  { SpdrClassification: RelationClassification.OutOfScope },
  // Corresponds to "not routed" and NULL on the Database
  { SpdrClassification: "-" },
];
